
import { initHistoryCarousels } from "./../js/historyCarousels/initHistoryCarousels.jsx";

initHistoryCarousels("history-carousel");
